import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';

const ActionModal = ({ type = 'success', title, message, onConfirm }) => {
    useEffect(() => {
        if (type === 'success') {
            const timer = setTimeout(() => {
                onConfirm();
            }, 2500);
            return () => clearTimeout(timer);
        }
    }, [onConfirm, type]);

    const isSuccess = type === 'success';

    return ReactDOM.createPortal(
        <div className="overlay-fade-in" style={{
            position: 'fixed', inset: 0, background: 'rgba(0, 0, 0, 0.4)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            zIndex: 10000, backdropFilter: 'blur(8px)', WebkitBackdropFilter: 'blur(8px)'
        }} onClick={onConfirm}>
            <div className="modal-fade-in" style={{
                width: 350, background: '#fff', borderRadius: 12, padding: 32,
                textAlign: 'center', boxShadow: '0 20px 25px -5px rgba(0,0,0,0.1)'
            }} onClick={e => e.stopPropagation()}>
                <div style={{
                    background: isSuccess ? '#e6f4ea' : '#fff1f0',
                    color: isSuccess ? '#1976d2' : '#d82c0d',
                    width: 56, height: 56, borderRadius: '50%',
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    margin: '0 auto 16px'
                }}>
                    {isSuccess ? (
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3"><polyline points="20 6 9 17 4 12" /></svg>
                    ) : (
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><circle cx="12" cy="12" r="10" /><line x1="12" y1="8" x2="12" y2="12" /><line x1="12" y1="16" x2="12.01" y2="16" /></svg>
                    )}
                </div>
                <h2 style={{ fontSize: 18, fontWeight: 700, marginBottom: 8, color: '#1a1c1d' }}>{title || (isSuccess ? 'Success' : 'Error')}</h2>
                <p style={{ fontSize: 13, color: '#6d7175', margin: isSuccess ? 0 : '0 0 24px' }}>
                    {message}
                </p>
                {!isSuccess && (
                    <button onClick={onConfirm} style={{
                        width: '100%', padding: '10px', borderRadius: 8, border: 'none',
                        background: '#1a1c1d', color: '#fff', fontWeight: 600, fontSize: 14, cursor: 'pointer'
                    }}>
                        Dismiss
                    </button>
                )}
            </div>
        </div>,
        document.body
    );
};

export default ActionModal;
